import { useCallback } from "react";
import { useChosenDepartment } from "../contexts/ChosenDepartment";
import { useOptionalWeekViewContext } from "../contexts/WeekView/WeekViewContext";
import type { SpecificPreference } from "../utils/models";
import { useRosterLookup } from "./useRosterLookup";

const NO_TIME_OFF: SpecificPreference[] = [];

/**
 * A nurse's time off and preferences, for the PTO warnings of shift edits. On the staffing pages it's the shown weeks'
 * (`timeOffByNurseId`), there before the staff list loads; elsewhere (Profile, Master Schedule, the staff app) the
 * staff list's.
 */
export const useNurseTimeOff = (): ((nurseId: number) => SpecificPreference[]) => {
	const weekView = useOptionalWeekViewContext();
	const { chosenDepartment } = useChosenDepartment();
	const { getNurseById } = useRosterLookup(chosenDepartment.department_id);
	const timeOffByNurseId = weekView?.timeOffByNurseId;

	return useCallback(
		(nurseId: number): SpecificPreference[] =>
			// DEFAULT: a nurse with no entry has no time off in the weeks, and one not on the staff list (or before it
			// loads) has none to warn about, as before.
			(timeOffByNurseId ? timeOffByNurseId.get(nurseId) : getNurseById(nurseId)?.employeeSpecificPreferences) ?? NO_TIME_OFF,
		[timeOffByNurseId, getNurseById],
	);
};
